module.exports = __webpack_public_path__ + "files/SPIADI2026 - OBSERVA4 - Fiche P4 (Version 1).60b8010640a9766f6d694a62bfba6a46.pdf";